import React from 'react';
import { motion } from 'framer-motion';

interface UserData {
  uid: string;
  email: string;
  displayName: string;
  photoURL: string;
  createdAt: any;
  lastLoginAt: any;
  totalWordsLearned: number;
  currentStreak: number;
  longestStreak: number;
}

interface UserProfileProps {
  userData: UserData;
  onSignOut: () => void;
  onClose: () => void;
}

const UserProfile: React.FC<UserProfileProps> = ({ userData, onSignOut, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        className="bg-white rounded-2xl shadow-2xl p-6 max-w-md w-full"
      >
        <div className="text-center">
          {/* Kullanıcı Avatar */}
          <div className="mb-6">
            {userData.photoURL ? (
              <img
                src={userData.photoURL}
                alt={userData.displayName}
                className="w-20 h-20 rounded-full mx-auto border-4 border-primary"
              />
            ) : (
              <div className="w-20 h-20 bg-gradient-to-r from-primary to-secondary rounded-full mx-auto flex items-center justify-center">
                <span className="text-white text-2xl font-bold">
                  {userData.displayName?.charAt(0) || userData.email?.charAt(0)}
                </span>
              </div>
            )}
          </div>

          {/* Kullanıcı Bilgileri */}
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            {userData.displayName || 'Kullanıcı'}
          </h2>
          <p className="text-gray-600 mb-6">{userData.email}</p>

          {/* İstatistikler */}
          <div className="grid grid-cols-3 gap-4 mb-6">
            <div className="text-center p-3 bg-blue-50 rounded-lg">
              <div className="text-2xl font-bold text-primary">
                {userData.totalWordsLearned}
              </div>
              <div className="text-sm text-gray-600">Öğrenilen</div>
            </div>
            <div className="text-center p-3 bg-green-50 rounded-lg">
              <div className="text-2xl font-bold text-secondary">
                {userData.currentStreak}
              </div>
              <div className="text-sm text-gray-600">Günlük Seri</div>
            </div>
            <div className="text-center p-3 bg-yellow-50 rounded-lg">
              <div className="text-2xl font-bold text-warning">
                {userData.longestStreak}
              </div>
              <div className="text-sm text-gray-600">En Uzun Seri</div>
            </div>
          </div>

          {/* Motivasyon Mesajı */}
          <div className="mb-6 p-4 bg-gradient-to-r from-primary to-secondary rounded-lg text-white">
            <p className="font-semibold">
              {userData.totalWordsLearned === 0 && "İlk kelimeni öğrenmeye başla!"}
              {userData.totalWordsLearned > 0 && userData.totalWordsLearned < 10 && "Harika gidiyorsun! Devam et!"}
              {userData.totalWordsLearned >= 10 && userData.totalWordsLearned < 50 && "Muhteşem! Kelime haznen büyüyor!"}
              {userData.totalWordsLearned >= 50 && userData.totalWordsLearned < 100 && "İnanılmaz! Sen bir kelime ustasısın!"}
              {userData.totalWordsLearned >= 100 && "Efsane! İngilizce konuşmaya hazırsın!"}
            </p>
          </div>

          {/* Butonlar */}
          <div className="space-y-3">
            <button
              onClick={onClose}
              className="w-full bg-primary text-white py-3 rounded-lg hover:bg-blue-600 transition-colors"
            >
              Devam Et
            </button>
            <button
              onClick={onSignOut}
              className="w-full bg-gray-200 text-gray-700 py-3 rounded-lg hover:bg-gray-300 transition-colors"
            >
              Çıkış Yap
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default UserProfile;
